import type { JobResponseType } from '../Jobs/types';
import type { Job } from '../Jobs/Job';

export class NotificationSystemContext {
    public jobAdHocNotRejectedQuery: number = 0;
    public jobAdHocRejectedQuery: number = 0;
    public jobRejectedQuery: number = 0;
    public jobAdHocNotRejected: Job[] = [];
    public jobAdHocRejected: Job[] = [];
    public jobRejected: Job[] = [];
}
